module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div tabindex="-1" role="menuitem" class="cw-menu-item-title d-flex align-items-center" data-ecran="'+
((__t=(id))==null?'':__t)+
'">\r\n    <span class="cw-menu-item-body d-flex flex-grow-1">\r\n        <a tabindex="0" href="'+
((__t=(href))==null?'':__t)+
'" class="'+
((__t=(id))==null?'':__t)+
' '+
((__t=(emid))==null?'':__t)+
' d-flex flex-grow-1">\r\n            <span class="cw-menu-element d-flex align-items-center flex-grow-1">\r\n                <span class="d-flex cw-menu-item-icon flex-shrink-0 ml-4"></span>\r\n                <span class="ctime-menu-item-libelle ml-3">'+
((__t=(nom))==null?'':__t)+
'</span>\r\n            </span>\r\n        </a>\r\n    </span>\r\n</div>\r\n';
}
return __p;
};
